module.exports = "mutation user($user:UserInput!){user(user:$user){id}}"